module.exports = __webpack_public_path__ + "img/dab_dworski_braz.f3b021a4.jpg";